
import { useState,useEffect } from 'react'
import './styles/UsersAdmin.css'
import Action from '../Action'
import { useFetch } from '../../hooks/useFetch'
import { useFetchPost } from '../../hooks/useFetchPost'
import Selector from '../Selector'
import LoadAdding from '../LoadAdding'
import LoadSimple from '../LoadSimple'
import UserList from './UserList'
import TableUsers from './TableUsers'
import ConfigUser from './ConfigUser'
import {roles}  from '../generales/GroupsId';
import Paginador from '../generales/Paginador'
import Search from '../generales/Search'
import { lang } from '../generales/traduction'
import { capitalizeFirstLetter } from '../../utils/utils'
import Modal from 'react-modal';
import ModalCreateUser from './ModalCreateUser'
const CreateCisModalStyles = {
    content: {
      top: "50%",
      left: "50%",
      background: "#ffffff !important",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "40%",
      height: "70%",
      padding: "20px",
    },
  };
const UsersAdmin=({server,languaje,mode,handleShowPopup})=>{
  const [limitList, setLimitList] = useState(50);
  const [pageActual, setPageActual] = useState(1);
  const startLimit = limitList * pageActual - limitList;
  const [dataMantto,setDataMantto]= useState([]);
  const [nivelForm,setNivelForm]=useState(1)
  const [userData,setUserData]=useState({name:"",mail:"",roles:"1"})
  const [disabled,setDisabled]=useState(true)

  const [registerIsValid, setRegisterIsValid] = useState(false);
  const [editActive, setEditActive] = useState(false);
  const [data,setData]=useState([]);
  const [loading,setLoading]=useState(false);
  const [error,setError]=useState(null);
  const [userId,setUserId]=useState(0)
  const [rol, setRol] = useState(2);
  const [dataUsers, setDataUsers] = useState({
      data: [],
      loading: true,
      error: null,
    });
  const [dataRoles,setDataRoles]=useState({data:[],loading:true,error:''})
  const [searchResults, setSearchResults] = useState([]);
  const [searchResult, setSearchResult] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  var dataList = searchTerm === "" ? dataUsers.data : searchResults;
  const [CreateCisModalOpen, setCreateCisModalOpen] = useState(false);
  const crear = () => {
      // Aquí puedes realizar la búsqueda usando el valor de 'query'
      // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
      setCreateCisModalOpen(true);
    };


  const pages = parseInt(dataList.length / limitList) + 1;
  // const dataRoles=useFetch('cassia/users/roles','',localStorage.getItem('access_token'),'GET',server)
  const getRoles=()=>{
      
      setDataRoles({data:dataRoles.data,loading:true,error:''})
        const fetchDataPost = async () => {
          
       try {
          
            const response = await fetch(server.url+'/api/v1/cassia/users/roles', {
              method: 'GET',  
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('access_token')}`,
              },
            });
          
            if (response.ok) {
              
              const data1 = await response.json();
             
              setDataRoles({data:data1,loading:false,error:''})
             
            } else {
              throw new Error('Error en la solicitud');
            }
          } catch (error) {
              setDataRoles({data:dataRoles.data,loading:false,error:''})
            console.error(error);
          }
        };
    
        fetchDataPost();
        
  
  }
  useEffect(()=>{
      getRoles()
  },[])
  const [checkboxes, setCheckboxes] = useState({
      checkbox1: false,
      checkbox2: false,
      checkbox3: false,
      checkbox4: false,
      checkbox5: false,
    });


  const handleChange=(e)=>{
    setRol(parseInt(e.target.value, 10))
    const {name,value}=e.target
    setUserData((prevState)=>{
        return {
            ...prevState,
            [name]:value
        }
        
    })
  }
  //     
  useEffect(()=>{
    if(data.length!==0){
        if(data.success===true ){
            setRegisterIsValid(true) 
            setUserData({name:"",mail:"",roles:"1"})
            
        }
    }
    const timer = setTimeout(() => {
        setRegisterIsValid(false)
        
      }, 3000);

    return () => {
      // Limpieza: cancelar el temporizador si el componente se desmonta antes de que expire
      clearTimeout(timer);
    };
  },[data])

  const handleChangform=()=>{
        nivelForm===1?setNivelForm(2):setNivelForm(1)
  }
  const Regresar=()=>{
    setUserData({name:"",mail:"",roles:"1"})
    setEditActive(false)
    setLoading(false)
  }
  const handleChangEdit=(user)=>{
    setLoading(false)
    
    const rolIds = user.roles.map(obj => obj.rol_id).join(',')
    
    setEditActive(true)
    setCreateCisModalOpen(true)
    getRoles()
    setUserData({name:user.name,mail:user.mail,roles:""+rolIds,groups:user.groups})
    setUserId(user.user_id)
    setRol(rolIds)
}



  const handleSearch = (query) => {
    // Aquí puedes realizar la búsqueda usando el valor de 'query'
    // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
    // setSearchResult(`Resultados para: ${query}`);
  };
  function closCreateCisModal() {
    setEditActive(false);
    setCreateCisModalOpen(false);
  }
  const handleSelectChange = (e) => {
    setLimitList(e.target.value);setPageActual(1);
  };

  const {name,mail}=userData
  return (
      <>
      <div className='head-cis'>
      <div className='title-cis'>
                  <Search
                      searchResults={searchResults}
                      setSearchResults={setSearchResults}
                      searchTerm={searchTerm}
                      setSearchTerm={setSearchTerm}
                      onSearch={handleSearch}
                      dataObject={dataUsers.data}
                      setDataObject={setDataUsers}
                      searchResult={searchResult}
                      setSearchResult={setSearchResult}
                      languaje={languaje}
                    />
            <div className={"cont-result-registers"+mode}>
           
                    <p style={{  textAlign: "center" }}>
                      &nbsp;
                      {capitalizeFirstLetter(lang[languaje]['resultadosEncontrados'])+" (" +
                        dataList.length +
                        ") " 
                        }
                    </p> 
            </div>
            <div className="cont-buttons-panel">
                    
                      <Action
                      disabled={false}
                      origen="Azul"
                      titulo={"+ "+capitalizeFirstLetter(lang[languaje]['nuevoRegistro'])}
                      action={crear}
                    />
                    
                   
                  </div>
                  </div>
                  
              </div>
              <div className='cont-cis'>
              <>
        <div className="main-panel-cis">
        <div className="compact-content-portafolio">
        <div className={"content-portafolio-head"+mode}>
                
                
                </div>
          <div className="content-portafolio">
            
  
            <div className="cont-portafolio-table">
              <div className="content-card-portafolio" id="content">
                {/*  aqui inicia */}
<>
<TableUsers setDataUsers={setDataUsers} dataUsers={dataUsers} pageActual={pageActual}  limitList={limitList} startLimit={startLimit} dataList={dataList} languaje={languaje} mode={mode} registerIsValid={registerIsValid}  server={server} handleChangEdit={handleChangEdit} setData={setData} setLoading={setLoading} setError={setError}/>
                              {/* <ConfigUser></ConfigUser> */}
                       
</>

       {/*  aqui termina */}         
              </div>
            </div>
          </div>
          <div className={"content-portafolio-footer"+mode}>
            <div className="cont-display-paginador">
                      <Paginador  pages={pages}
                                  pageActual={pageActual}
                                  setPageActual={setPageActual}
                                  mode={mode}></Paginador>
            </div>
            <div className="cont-display-paginador">
              <div className={"cont-half-display-paginador"+mode}>
              <div>
    <label htmlFor="selector">{capitalizeFirstLetter(lang[languaje]['filasPagina'])}: </label>
    <select id="selector" value={limitList} className="pageSelector" onChange={handleSelectChange}>
      <option value={10}>10</option>
      <option value={50} >50</option>
      <option value={100}>100</option>
      <option value={500}>500</option>
      <option value={1000}>1000</option>
    </select>

    
  </div>
                    
              </div>
              <div className={"cont-half-display-paginador"+mode}>
              <p style={{  textAlign: "center" }}>
                              &nbsp;
                              {"(" +
                          (startLimit + 1) +
                          " - " +
                          (dataList.length >  parseInt(pageActual ) * parseInt(limitList)
                            ?  parseInt(pageActual ) * parseInt(limitList)
                            : dataList.length) +
                          ")  "+lang[languaje]['de']+" " +
                          dataList.length +
                          " "+lang[languaje]['resultados']}
                        </p>
                    
              </div>
            </div>  
                      
          </div>
          </div>
  
        </div>
        <Modal
          isOpen={CreateCisModalOpen}
          // isOpen={false}
          // onAfterOpen={afterOpenExeption}
          onRequestClose={closCreateCisModal}
          style={CreateCisModalStyles}
          contentLabel="Example Modal2"
          shouldCloseOnOverlayClick={false}
        >
        <ModalCreateUser
      //   devices={devices}
        server={server}
        editActive={editActive}
        setEditActive={setEditActive}
      //   dataCis={dataCis}
        setData={setData}
        loading={loading}
        setLoading={setLoading}
        setError={setError}
        setRegisterIsValid={setRegisterIsValid}
        closCreateCisModal={closCreateCisModal}
        dataMantto={userData}
        languaje={languaje}
                        mode={mode}
                        dataRoles={dataRoles}
                        userData={userData}
                      //   addRoles={addRoles}
                        userId={userId}
                        getRoles={getRoles}
                        handleShowPopup={handleShowPopup}
      ></ModalCreateUser>
      </Modal>
      </>
                  
              </div>
      </>
  )
}

export default UsersAdmin